export default "__VITE_ASSET__Z9Yo1wn5__"